<template>
  <div class="main-dashboard-panel program-details-page">
    <div class="panel-topnav container-fluid">
      <router-link :to="routeForProgramList" class="back-link pull-left">
        <i class="ion-ios-arrow-back text-yellow before"></i> All programs
      </router-link>

      <ul class="nav nav-tabs">
        <li>
          <h3 class="page-title">Program: {{ program.name }}</h3>
        </li>
      </ul>

      <div class="panel-controls ml-auto" v-if="atEdit || atSettings">
        <a href class="btn btn-primary" @click.prevent="save()">
          Save
        </a>
      </div>
      <div class="clearfix"></div>
    </div>

    <div class="container-fluid pane">
      <ul class="flex my-6 list-none border-b">
        <li class="mr-1" :class="atEdit && '-mb-px'">
          <router-link
            :to="routeForProgramEdit"
            class="inline-block px-4 py-2 font-semibold text-gray-500 bg-white"
            exact-active-class="text-gray-700 border-t border-l border-r rounded-t hover:text-black hover:cursor-default hover:no-underline "
          >
            Form
          </router-link>
        </li>
        <li class="mr-1" :class="atResults && '-mb-px'">
          <router-link
            :to="routeForProgramResults"
            class="inline-block px-4 py-2 font-semibold text-gray-500 bg-white"
            exact-active-class="text-gray-700 border-t border-l border-r rounded-t hover:text-black hover:cursor-default hover:no-underline "
          >
            Results
          </router-link>
        </li>
        <li v-if="atAdmin" class="mr-1" :class="atSettings && '-mb-px'">
          <router-link
            :to="routeForProgramSettings"
            class="inline-block px-4 py-2 font-semibold text-gray-500 bg-white"
            exact-active-class="text-gray-700 border-t border-l border-r rounded-t hover:text-black hover:cursor-default hover:no-underline "
          >
            Settings
          </router-link>
        </li>
      </ul>

      <router-view ref="programDetailsRouterView" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import _ from 'lodash'
import ProgramOrganizationIdMixin from '@/modules/dashboard-organizer/ProgramOrganizationIdMixin'

export default {
  mixins: [ProgramOrganizationIdMixin],
  computed: {
    routeForProgramList() {
      return {
        name: this.atAdmin
          ? 'adminOrganizationProgramList'
          : 'dashboardOrganizationProgramList',
        params: this.routeParams,
      }
    },
    routeForProgramEdit() {
      return {
        name: this.atAdmin
          ? 'adminOrganizationProgramEdit'
          : 'dashboardOrganizationProgramEdit',
        params: this.routeParams,
      }
    },
    routeForProgramResults() {
      return {
        name: this.atAdmin
          ? 'adminOrganizationProgramResults'
          : 'dashboardOrganizationProgramResults',
        params: this.routeParams,
      }
    },
    routeForProgramSettings() {
      return {
        name: 'adminOrganizationProgramSettings',
        params: this.routeParams,
      }
    },
    atAdmin() {
      return _.startsWith(this.$route.name, 'admin')
    },
    atEdit() {
      const routeName = this.$route.name
      if (this.atAdmin) {
        return routeName === 'adminOrganizationProgramEdit'
      } else {
        return routeName === 'dashboardOrganizationProgramEdit'
      }
    },
    atResults() {
      const routeName = this.$route.name
      if (this.atAdmin) {
        return routeName === 'adminOrganizationProgramResults'
      } else {
        return routeName === 'dashboardOrganizationProgramResults'
      }
    },
    atSettings() {
      const routeName = this.$route.name
      return routeName === 'adminOrganizationProgramSettings'
    },
    routeParams() {
      return {
        organizationId: this.realOrganizationId,
        programId: this.programId,
      }
    },
    ...mapState({
      program: (state) => state.organizationProgramDetails.program,
      fetchInProgress: (state) =>
        state.user.fetchInProgress ||
        state.organizationProgramDetails.fetchInProgress,
    }),
  },
  methods: {
    save() {
      this.$refs.programDetailsRouterView.save()
    },
  },
}
</script>
